import type { ConventionPerformerVisibility } from '../performerLaunches'

export interface PerformerCardProps extends ConventionPerformerVisibility {
  name: string
  magicianSlug?: string
  image: string
  alt: string
  description: string
}

export const performers: PerformerCardProps[] = [
  {
    name: 'Guy Hollingworth',
    magicianSlug: 'guy-hollingworth',
    image:
      'https://vinc.gumlet.io/pics/conventions/magifest/performers/guy-hollingworth.jpg',
    alt: 'Guy Hollingworth',
    description:
      'Guy Hollingworth is one of the world’s most respected card magicians, known for his elegant, highly original sleight of hand and sophisticated approach to close-up magic. He is the author of Drawing Room Deceptions, a book that rocked the magic industry and influenced a generation of magicians. We couldn’t be more excited to welcome Guy back to Magifest after eight years to celebrate the release of the highly anticipated sequel, More Drawing Room Deceptions. This is a rare chance to see Guy live, get your book signed, and learn from one of our industry’s most prolific creators.',
  },
  {
    name: 'Colin McLeod',
    magicianSlug: 'colin-mcleod',
    image:
      'https://vinc.gumlet.io/pics/conventions/magifest/performers/colin-mcleod.jpg',
    alt: 'Colin McLeod',
    description:
      'Our Magifest Guest of Honor for 2027 is the one and only Colin McLeod! Originally from Scotland, Colin is a seasoned performer and known to be just about as close as you can get to a real-life Sherlock Holmes. While he is the only mentalist in history to perform shows on London’s West End, Broadway, and Las Vegas, he has experience in just about every area of magic and mentalism you can think of. From close-up to stage, from his own solo shows to his work with the Illusionists tour, he’s bringing his wealth of knowledge to Magifest this January.',
  },
  {
    name: 'Brian Curry',
    magicianSlug: 'brian-curry',
    image:
      'https://vinc.gumlet.io/pics/conventions/magifest/performers/brian-curry.jpg',
    alt: 'Brian Curry',
    description:
      "Brian Curry is a Washington, DC-based magician and mentalist best known for his acclaimed show The Good Liar. Brian's unique combination of mind reading, comedy, and tons of audience interaction has resulted in countless corporate shows, cruise ships, and live theater performances across all seven continents. At Magifest 2027, Brian will deliver his incredible show and then lecture on a topic he excels in: character development.",
  },
  {
    name: 'Dana Pleasant',
    magicianSlug: 'dana-pleasant',
    image:
      'https://vinc.gumlet.io/pics/conventions/magifest/performers/dana-pleasant.jpg',
    alt: 'Dana Pleasant',
    description:
      'After beginning her magical journey through classes at the Academy of Magical Arts, Dana has worked her way through the Magic Castle, becoming a magician member and regular performer in the Close-Up Gallery. At Magifest 2027, Dana will be our bar-magician-in-residence, amazing you in the after-hours jam sessions with her original brand of magic.',
  },
  {
    name: 'Siegfried Tieber',
    magicianSlug: 'siegfried-tieber',
    image:
      'https://vinc.gumlet.io/pics/conventions/magifest/performers/siegfried-tieber.jpg',
    alt: 'Siegfried Tieber',
    description:
      "Born and raised in Ecuador before moving to LA, Siegfried is known for his fun, story-driven close-up magic and mentalism. He's appeared twice on Penn & Teller: Fool Us, and in 2015, he headlined at the Edinburgh Fringe Festival, the largest arts festival in the world. We're excited to see his full show and a lecture at Magifest 2027. Now if only someone could get him to write a book...",
  },
  {
    name: 'John Shryock',
    magicianSlug: 'john-shryock',
    image:
      'https://vinc.gumlet.io/pics/conventions/magifest/performers/john-shryock.jpg',
    alt: 'John Shryock',
    description:
      "John Shryock is a veteran stage and close-up magician known for high-energy comedy and polished sleight of hand. He has appeared on Masters of Illusion, performed at venues like The Magic Castle and Caesars Palace, and recently published his first book, Maestro. At Magifest 2027, we'll have the pleasure of watching him perform AND having him lecture. We can't wait!",
  },
  {
    name: 'Kevin King',
    magicianSlug: 'kevin-king',
    image:
      'https://vinc.gumlet.io/pics/conventions/magifest/performers/kevin-king.jpg',
    alt: 'Kevin King',
    description:
      "Kevin King is a comedy magician, memory expert, and motivational speaker from Tennessee. We've invited Kevin to deliver an important talk that will not only improve your magic, but also change the way you see Kevin forever.",
  },
  {
    name: 'Lloyd Barnes',
    magicianSlug: 'lloyd-barnes',
    image:
      'https://vinc.gumlet.io/pics/conventions/magifest/performers/lloyd-barnes.jpg',
    alt: 'Lloyd Barnes',
    description:
      "Lloyd Barnes is a Welsh magician, creator, and YouTuber known for highly visual, modern magic that blends sleight of hand with clever gimmicks and technology. Even though his tricks like The Void have been massive successes, Lloyd hasn't lectured much in the US. But after his incredible lecture at The Session 2026, we knew we had to get him to come to Ohio for Magifest.",
  },
  {
    name: 'Margaret Steele',
    magicianSlug: 'margaret-steele',
    image:
      'https://vinc.gumlet.io/pics/conventions/magifest/performers/margaret-steele.jpg',
    alt: 'Margaret Steele',
    description:
      "Margaret has been performing magic for over twenty years, and has worked everywhere from the Magic Castle to classrooms and communities across the globe. Outside of her work performing, she is a renowned magic historian and a widely sought-after lecturer and presenter. At Magifest 2027, she'll be presenting the results of her research into the Great Boomsky, America's first Black Superstar Magician.",
  },
  {
    name: 'John Bannon',
    magicianSlug: 'john-bannon',
    image:
      'https://vinc.gumlet.io/pics/conventions/magifest/performers/john-bannon-2.jpg',
    alt: 'John Bannon',
    description:
      "A Chicago attorney and prolific magic author, John Bannon is known for practical, deceptive card magic and his acclaimed books, including Very Hush-Hush, Decked Out, and Destination Zero. Bannon has a unique ability to create magic that hits hard while staying accessible to magicians of all skill levels. We can't wait for him to lecture on semi-automatic card magic and jam in the lobby at Magifest 2027.",
  },
  {
    name: 'Mortenn Christiansen',
    magicianSlug: 'mortenn-christiansen',
    image:
      'https://vinc.gumlet.io/pics/conventions/magifest/performers/mortenn-christiansen.jpg',
    alt: 'Mortenn Christiansen',
    description:
      'Mortenn Christiansen is a Danish comedy magician whose offbeat, highly original style has earned him major international recognition. He won First Prize in Comedy Magic at FISM 2022 and First Prize in Parlor Magic at FISM 2025, making him one of today’s standout comedy magic performers. At Magifest 2027, we’ve gotten him to do a show AND a lecture, so come ready to laugh and learn!',
  },
]

export const scheduleHosts = [
  {
    name: 'Joshua Jay',
    magicianSlug: 'joshua-jay',
    image: 'https://vinc.gumlet.io/pics/hire-a-magician/joshua-jay.jpg',
    alt: 'Joshua Jay',
  },
  {
    name: 'Andi Gladwin',
    magicianSlug: 'andi-gladwin',
    image: 'https://vinc.gumlet.io/pics/hire-a-magician/andi-gladwin.jpg',
    alt: 'Andi Gladwin',
  },
]
